export const types = {
  SET_BILLING_PERIOD: 'SET_BILLING_PERIOD',
  SET_INVOICE_DATE: 'SET_INVOICE_DATE',
  SET_TABLE_COSTS_CALCULATED: 'SET_TABLE_COSTS_CALCULATED',
  SET_ORGANIZATIONS_USAGE_STATS: 'SET_ORGANIZATIONS_USAGE_STATS',
  UPDATE_COST: 'UPDATE_COST',
};
